import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ActivityDTO, ActivityState, RegisterActivityRequest} from '@domain/activity/activity.dto';
import {ApiUtil} from '@shared/util/apiUtil';

@Injectable({
  providedIn: 'root'
})
export class HostActivityApi {

  constructor(
    private readonly http: HttpClient
  ) { }

  public getAllActivities(hostId: string | null): Observable<ActivityDTO[] | null> {
    return this.getActivities(hostId);
  }

  public getPublishedActivities(hostId: string | null): Observable<ActivityDTO[] | null> {
    return this.getActivities(hostId, ActivityState.Published);
  }

  public registerActivity(hostId: string, registerActivityRequest: RegisterActivityRequest): Observable<ActivityDTO | null> {
    return this.http.post<ActivityDTO>(ApiUtil.buildUrl(this.getPath(hostId), '/register'), registerActivityRequest);
  }

  private getActivities(hostId: string | null, activityState: ActivityState | null = null): Observable<ActivityDTO[] | null> {
    if (!hostId) {
      return of(null);
    }
    return this.http.get<ActivityDTO[]>(ApiUtil.buildUrl(this.getPath(hostId), '', activityState ? {state: activityState} : {}));
  }

  private getPath(hostId: string): string {
    const prefix = 'host';
    const suffix = 'activity'
    return `${prefix}/${hostId}/${suffix}`;
  }
}
